import parseCompareItems from './parse-compare-items.js';
import { compareItemsLSKey } from '../../../configuration/index.js';

// When another tab changes localStorage compareItems, this event is dispatched
self.addEventListener('storage', ({ key, newValue, storageArea, url }) => {
  if (storageArea !== localStorage || key !== compareItemsLSKey) {
    return;
  }

  self.dispatchEvent(
    new CustomEvent('compare', {
      bubbles: true,
      detail: {
        // Note: tracking data (productDataLayer) is not available in cross-tab sync
        ...parseCompareItems(newValue),
        origin: url
      }
    })
  );
});
